import I18n from "i18n-js";
import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text } from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";

class PrescriptionHistoryOrderStatusDetail extends React.Component {
  static propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    status: PropTypes.string.isRequired,
    isLargeDetail: PropTypes.bool,
    rejectReason: PropTypes.string,
  };

  render() {
    const { date, status, isLargeDetail, rejectReason } = this.props;

    return (
      <>
        <Text
          style={[
            isLargeDetail ? styles.sectionLarge : styles.section,
            { textTransform: "uppercase" },
          ]}
        >
          {status}
        </Text>
        <Text style={isLargeDetail ? styles.timestampLarge : styles.timestamp}>
          {`${I18n.l("date.prixa.default", date)} jam ${I18n.l(
            "time.prixa.default",
            date
          )}`}
        </Text>
        {status.toLowerCase() === "resep ditolak" && (
          <Text style={styles.section}>{`${I18n.t(
            "prixa.prescriptionRejectReason",
            {
              reason: rejectReason.toLowerCase() || "",
            }
          )}`}</Text>
        )}
      </>
    );
  }
}

const styles = StyleSheet.create({
  sectionLarge: {
    fontSize: 16,
    ...fonts.bold,
  },
  section: {
    fontSize: 14,
    ...fonts.bold,
  },
  timestamp: {
    fontSize: 12,
    ...fonts.regular,
  },
  timestampLarge: {
    fontSize: 14,
    ...fonts.regular,
  },
});

export default connect((state) => ({
  themeColors: state.themeColors,
}))(PrescriptionHistoryOrderStatusDetail);
